import { ReactNode, useMemo } from 'react';
import { useGlobalComponentForAttribute } from '@rhino-project/core/hooks';
import { useModelAndAttributeFromPath } from '@rhino-project/core/hooks';
import { RhinoResourceSpecifier } from '@rhino-project/core';
import { Header } from '../table/Header';

export interface ModelHeaderProps {
  model: RhinoResourceSpecifier;
  path: string;
  children?: ReactNode;
  [key: string]: unknown;
}

export const ModelHeaderBase = ({
  model,
  path,
  children,
  ...props
}: ModelHeaderProps) => {
  const { attribute } = useModelAndAttributeFromPath(model, path);
  const headerText = useMemo(
    () => children || attribute?.readableName,
    [children, attribute]
  );

  return <Header {...props}>{headerText}</Header>;
};

export const ModelHeader = (props: ModelHeaderProps) =>
  useGlobalComponentForAttribute('ModelHeader', ModelHeaderBase, props);
